class ColorSwatch extends HTMLElement {
  constructor() {
      super();
      this.attachShadow({ mode: 'open' });
  }
  
  connectedCallback() {
      this.productId = this.getAttribute('product-id');
      this.imgUrl = this.getAttribute('img-url');
      this.hexCode = this.getAttribute('hex-code');
      this.isActive = this.getAttribute('checked');
      const input = this.querySelector('input[type="radio"]');
      this.variantName = this.getAttribute('variant-name');
  
      this.renderSwatch();
  
      this.shadowRoot.querySelector('.circle-wrapper')
      .addEventListener('click', () => this.onClickHandler());
  }
  
  async onClickHandler() {
      // Don't refetch if this swatch is already active
      if (this.isActive) {
          return;
      }
  
      try {
          document.getElementById('main-product-atm').classList.add('loading');
  
          const productUrl = `/products/${this.productId}`;
  
          const response = await fetch(productUrl, { method: 'GET' });
          if (!response.ok) {
              throw new Error(`Failed to fetch product HTML for variant ${this.variantId}`);
          }
  
          const htmlText = await response.text();
  
          const parser = new DOMParser();
          const doc = parser.parseFromString(htmlText, 'text/html');
          const newMainProductAtm = doc.querySelector('#main-product-atm');
  
          if (newMainProductAtm) {
              const currentMainProductAtm = document.querySelector('#main-product-atm');
              if (currentMainProductAtm) {
                  currentMainProductAtm.replaceWith(newMainProductAtm);
                  // Initialize all necessary JS after replacing the content
                  initializeProductFunctionality();
              }
          }
  
          window.history.pushState({}, '', productUrl);
      } catch (err) {
          console.error('Error in onClickHandler:', err);
      }
  }
  
  renderSwatch() {
      const wrapper = document.createElement('div');
      wrapper.className = 'circle-wrapper';
      wrapper.style.display = 'inline-block';
      wrapper.style.cursor = 'pointer';
  
      const circle = document.createElement('div');
      circle.className = 'circle';
      circle.style.width = '32px';
      circle.style.height = '32px';
      circle.style.borderRadius = '50%';
      circle.style.overflow = 'hidden';
      circle.style.display = 'flex';
      circle.style.alignItems = 'center';
      circle.style.justifyContent = 'center';
      wrapper.style.margin = '5px';
  
      // Add active styling
      if (this.isActive) {
          circle.style.border = '2px solid white';
          circle.style.outline = '1px solid black';
          // Optional: Add other active state styles
          
      } else {
          circle.style.border = '1px solid #ddd';
      }
  
      if (this.imgUrl) {
          const img = document.createElement('img');
          img.src = this.imgUrl;
          img.style.width = '100%';
          img.style.height = '100%';
          img.style.objectFit = 'cover';
          img.alt = this.variantName || 'Color variant';
          circle.appendChild(img);
      } else if (this.hexCode) {
          circle.style.backgroundColor = this.hexCode;
      }
  
      const tooltip = document.createElement('span');
      tooltip.className = 'color-tooltip';
      tooltip.textContent = this.variantName || '';

      const style = document.createElement('style');
      style.textContent = `
        .circle-wrapper {
          position: relative;
          display: inline-block;
        }
        .color-tooltip {
          position: absolute;
          bottom: calc(100% + 6px);
          left: 50%;
          transform: translateX(-50%);
          background: #000;
          color: #fff;
          padding: 5px 8px;
          font-size: 12px;
          line-height: 1;
          white-space: nowrap;
          border-radius: 3px;
          opacity: 0;
          visibility: hidden;
          pointer-events: none;
          transition: opacity 0.15s ease;
          z-index: 10;
        }

        .circle-wrapper:hover .color-tooltip,
        .circle-wrapper:focus-within .color-tooltip {
          opacity: 1;
          visibility: visible;
        }
      `;
  
      wrapper.appendChild(circle);
      if (this.variantName) {
        wrapper.appendChild(tooltip);
      }
  
      this.shadowRoot.innerHTML = '';
      this.shadowRoot.appendChild(style);
      this.shadowRoot.appendChild(wrapper);
  }
  }
  
  customElements.define('color-swatch', ColorSwatch);
  
  window.addEventListener('popstate', async () => {
      try {
          const response = await fetch(window.location.href);
          if (!response.ok) throw new Error('Failed to fetch page content');
  
          const htmlText = await response.text();
          const parser = new DOMParser();
          const doc = parser.parseFromString(htmlText, 'text/html');
          const newMainProductAtm = doc.querySelector('#main-product-atm');
  
          if (newMainProductAtm) {
              const currentMainProductAtm = document.querySelector('#main-product-atm');
              if (currentMainProductAtm) {
                  currentMainProductAtm.replaceWith(newMainProductAtm);
                  // Initialize all necessary JS after replacing the content
                  initializeProductFunctionality();
              }
          }
      } catch (err) {
          console.error('Error handling navigation:', err);
          // Fallback to full page reload if something goes wrong
          window.location.reload();
      }
  });
  
  function handleKlaviyoClick(e) {
      e.preventDefault();
      window._klOnsite = window._klOnsite || []; 
      window._klOnsite.push(['openForm', 'Yi8fnE']);
    }
  
  // Create a single initialization function for product functionality
  function initializeProductFunctionality() {
      console.log("Initializing product functionality...");
      const content = document.querySelector('.main-product-container__content');
      const container = document.querySelector('.main-product-container');
      const sizeGuideButton = document.getElementById('size-guide-button');
      const sizeFieldset = document.querySelector('.size-selector fieldset');
  
      const selectedRadio = sizeFieldset.querySelector('input[type="radio"]:checked');
      console.log(selectedRadio.dataset)
  
      if (selectedRadio.dataset.available === "false" && selectedRadio.dataset.preDate === "00"){
        atcButton = document.querySelectorAll('.add-to-cart-button button');
        atcButton.forEach((button) => {
            button.innerText = "EMAIL ME WHEN AVAILABLE";
            button.classList.add("klaviyo_form_trigger");
            button.addEventListener('click', handleKlaviyoClick)
        })
      } else if (selectedRadio.dataset.available === "true" && selectedRadio.dataset.preDate !== "00"){
        atcButton = document.querySelectorAll('.add-to-cart-button button');
        atcButton.forEach((button) => {
          button.innerText = selectedRadio.dataset.preorderMsg.toUpperCase();
          const preDateText = document.getElementById('pre-date-text');
          preDateText.style.display = "block";
          preDateText.innerText = `${selectedRadio.dataset.preorderMsg}: Expected to ship ${selectedRadio.dataset.preDate.toUpperCase()}`;
          const form = button.querySelector('.pre-data-attr');
          if (!form) {
            propertyInput = document.createElement('input');
            propertyInput.type = 'hidden';
            propertyInput.name = `properties[${selectedRadio.dataset.preorderMsg} expected to ship]`;
            propertyInput.classList.add('pre-data-attr');
            propertyInput.value = selectedRadio.dataset.preDate.toUpperCase();
            button.appendChild(propertyInput);
          } else {  
            form.value = selectedRadio.dataset.preDate.toUpperCase();
          }
        })
      }
    
  
      // Initialize PhotoSwipe lightbox if gallery exists
      initializePhotoSwipe();
      initializeMobileGallery();
  
      // Only attach event listeners if elements exist
      if (sizeFieldset) {
          // Remove existing listeners first to prevent duplicates
          const newSizeFieldset = sizeFieldset.cloneNode(true);
          sizeFieldset.parentNode.replaceChild(newSizeFieldset, sizeFieldset);
          
          // Reattach event listener
          newSizeFieldset.addEventListener('change', (e) => {
              if (e.target.classList.contains('size-radio')) {
                  const selectedValue = e.target.value;
                  const available = e.target.dataset.available;
                  const preDateData = e.target.dataset.preDate;
                  const preTextData = e.target.dataset.preorderMsg;
                  const preDateText = document.getElementById('pre-date-text');
                  document.dispatchEvent(new CustomEvent('size-variant-changed'));
  
                  const newUrl = new URL(window.location.href);
                  newUrl.searchParams.set('variant', selectedValue);
                  window.history.replaceState({}, '', newUrl);
  
                  atcButton = document.querySelectorAll('.add-to-cart-button button');
                    
                    atcButton.forEach((button) => {
                      let form = button.querySelector('.pre-data-attr');
                      if (available === "true" && preDateData === "00") {
                        button.innerText = "ADD TO BAG";
                        button.classList.remove("klaviyo_form_trigger");
                        button.removeEventListener('click', handleKlaviyoClick);
                        preDateText.style.display = "none";
                          if (form) {
                            form.remove();
                          }
                      } else if (preTextData !== ""  && available === "true") {
                          button.innerText = preTextData.toUpperCase();
                          preDateText.style.display = "block";
                          preDateText.innerText = `${preTextData}: Expected to ship ${preDateData}`;
                          button.classList.remove("klaviyo_form_trigger");
                          button.removeEventListener('click', handleKlaviyoClick);
                          
                          // Add or update the property input
                          form = button.querySelector('.pre-data-attr');
                          if (!form) {
                            propertyInput = document.createElement('input');
                            propertyInput.type = 'hidden';
                            propertyInput.name = `properties[${preTextData} expected to ship]`;
                            propertyInput.classList.add('pre-data-attr');
                            propertyInput.value = preDateData
                            button.appendChild(propertyInput);
                          } else {
                            form.value = preDateData;
                          }
                      } else {
                        button.innerText = "EMAIL ME WHEN AVAILABLE";
                        button.classList.add("klaviyo_form_trigger");
                        button.addEventListener('click', handleKlaviyoClick);
                        preDateText.style.display = "none";
                        if (form) {
                          form.remove();
                        }
                      }
                    });
  
  
                  const cartVariantInputs = document.querySelectorAll('.add-to-cart-button input[name="id"]');
                  if (cartVariantInputs && cartVariantInputs.length > 0) {
                      cartVariantInputs.forEach(input => {
                          input.value = selectedValue;
                      });
                  }
              }
          });
  
        
      }
  
      function onSizeGuideClick(e) {
          e.preventDefault();
          document.dispatchEvent(new CustomEvent('size-guide-opened'));
          const sizeGuide = document.getElementById('size-guide');
          if (sizeGuide) {
            sizeGuide.showModal();
          } else {
            console.warn('Size guide not found');
          }
      }
  
      // Reattach size guide event listener
      if (sizeGuideButton) {
  
          // Remove the click if it was previously attached
          sizeGuideButton.removeEventListener('click', onSizeGuideClick);
  
          // Attach fresh listener
          sizeGuideButton.addEventListener('click', onSizeGuideClick);
      }
  
      // Keep the scroll handling here since it's for the entire page
  
  }
  
  // Function to initialize PhotoSwipe
  function initializePhotoSwipe() {
      // Check if we need to load the modules
      if (typeof PhotoSwipeLightbox === 'undefined') {
          // Dynamic import for PhotoSwipe
          import('./photoswipe-lightbox.esm.min.js').then(module => {
              const PhotoSwipeLightbox = module.default;
              const lightbox = new PhotoSwipeLightbox({
                  gallery: '#main-gallery',
                  children: 'a',
                  pswpModule: () => import('./photoswipe.esm.min.js')
              });
              lightbox.init();
          }).catch(error => {
              console.error('Error loading PhotoSwipe:', error);
          });
      } else {
          // PhotoSwipe is already loaded, just initialize it
          const lightbox = new PhotoSwipeLightbox({
              gallery: '#main-gallery',
              children: 'a',
              pswpModule: () => import('./photoswipe.esm.min.js')
          });
          lightbox.init();
      }
  }
  
  class MegaMenu {
      constructor() {
        this.menuItems = document.querySelectorAll('[data-has-megamenu="true"]');
        this.init();
      }
    
      init() {
        // Add hover intent
        let timeout;
        const delay = 200; // milliseconds
    
        this.menuItems.forEach(item => {
          item.addEventListener('mouseenter', () => {
            clearTimeout(timeout);
            this.closeAllMenus();
            item.classList.add('is-active');
          });
    
          item.addEventListener('mouseleave', () => {
            timeout = setTimeout(() => {
              item.classList.remove('is-active');
            }, delay);
          });
        });
      }
    
      closeAllMenus() {
        this.menuItems.forEach(item => item.classList.remove('is-active'));
      }
    }
    
    // Initialize
    window.addEventListener('DOMContentLoaded', () => {
      new MegaMenu();
      initializeProductFunctionality()
    });
  
    function initializeMobileGallery() {
      // Only run on mobile
      function isMobile() {
        return window.innerWidth <= 768;
      }
      
      const imageContainer = document.querySelector('.image-container');
      const images = document.querySelectorAll('.image-container__image');
      const buttons = document.querySelectorAll('.gallery-button');
      if (!imageContainer || !images.length || !buttons.length) return;
      
      // Initial setup
      function setupMobileGallery() {
        if (!isMobile()) return;
        
        // Make images focusable for keyboard navigation
        images.forEach(image => {
          image.setAttribute('tabindex', '0');
          image.setAttribute('role', 'img');
          if (!image.querySelector('img').alt) {
            image.setAttribute('aria-label', 'Product image');
          }
        });
        
        updateActiveButton();
      }
      
      // Enhanced button setup - works on any screen size
      buttons.forEach((button, index) => {
        button.setAttribute('aria-label', `View image ${index + 1} of ${buttons.length}`);
        button.setAttribute('aria-controls', 'product-gallery');
        
        button.addEventListener('click', () => {
          if (isMobile()) {
            scrollToImage(index);
          }
        });
      });
      
      // Mobile-only events
      function setupMobileEvents() {
        if (!isMobile()) return;
        
        // Keyboard navigation
        imageContainer.addEventListener('keydown', handleKeyNavigation);
        
        // Touch events for swipe
        imageContainer.addEventListener('touchstart', handleTouchStart, { passive: true });
        imageContainer.addEventListener('touchend', handleTouchEnd, { passive: true });
        
        // Scroll detection
        imageContainer.addEventListener('scroll', handleScroll, { passive: true });
      }
      
      // Remove mobile events when not needed
      function removeMobileEvents() {
        imageContainer.removeEventListener('keydown', handleKeyNavigation);
        imageContainer.removeEventListener('touchstart', handleTouchStart);
        imageContainer.removeEventListener('touchend', handleTouchEnd);
        imageContainer.removeEventListener('scroll', handleScroll);
      }
      
      // Event handlers
      let touchStartX = 0;
      let touchEndX = 0;
      let scrollTimeout;
      
      function handleKeyNavigation(e) {
        const currentIndex = getCurrentIndex();
        if (e.key === 'ArrowLeft' && currentIndex > 0) {
          scrollToImage(currentIndex - 1);
        } else if (e.key === 'ArrowRight' && currentIndex < images.length - 1) {
          scrollToImage(currentIndex + 1);
        }
      }
      
      function handleTouchStart(e) {
        touchStartX = e.changedTouches[0].screenX;
      }
      
      function handleTouchEnd(e) {
        touchEndX = e.changedTouches[0].screenX;
        handleSwipe();
      }
      
      function handleScroll() {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(updateActiveButton, 100);
      }
      
      function handleSwipe() {
        const currentIndex = getCurrentIndex();
        const threshold = 50; // Minimum swipe distance in pixels
        
        if (touchEndX < touchStartX - threshold && currentIndex < images.length - 1) {
          // Swipe left - go to next image
          scrollToImage(currentIndex + 1);
        } else if (touchEndX > touchStartX + threshold && currentIndex > 0) {
          // Swipe right - go to previous image
          scrollToImage(currentIndex - 1);
        }
      }
      
      // Helper functions
      function getCurrentIndex() {
        const scrollPosition = imageContainer.scrollLeft;
        const imageWidth = imageContainer.offsetWidth;
        return Math.round(scrollPosition / imageWidth);
      }
      
      function scrollToImage(index) {
        if (!isMobile()) return;
        
        const imageWidth = imageContainer.offsetWidth;
        imageContainer.scrollTo({
          left: index * imageWidth,
          behavior: 'smooth'
        });
        updateActiveButton(index);
      }
      
      function updateActiveButton(index = null) {
        const activeIndex = index !== null ? index : getCurrentIndex();
        
        buttons.forEach((button, i) => {
          if (i === activeIndex) {
            button.classList.add('active');
            button.setAttribute('aria-current', 'true');
          } else {
            button.classList.remove('active');
            button.removeAttribute('aria-current');
          }
        });
      }
      
      // Initial setup
      setupMobileGallery();
      setupMobileEvents();
      
      // Handle resize events to add/remove mobile functionality
      window.addEventListener('resize', () => {
        if (isMobile()) {
          setupMobileGallery();
          setupMobileEvents();
        } else {
          removeMobileEvents();
        }
      });
    };
  
  
  function onSwymLoadCallback(swat) {
      swat.evtLayer.addEventListener(swat.JSEvents.UIAddedToCart, function() {
          window.dispatchEvent(new CustomEvent('product:added-to-cart', { bubbles: true }));
      });
  }
  
  if (!window.SwymCallbacks) {
      window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(onSwymLoadCallback);
  
  window.addEventListener('product:added-to-cart', async function() {
      try {
          const response = await fetch(window.Shopify.routes.root + "?sections=cart-drawer", {
              method: 'GET',
              headers: { 'Content-Type': 'application/json' }
          });
  
          if (!response.ok) return;
  
          const newCart = await response.json();
          const cartDrawer = document.querySelector('cart-drawer');
  
          if (cartDrawer) {
              const html = new DOMParser().parseFromString(newCart["cart-drawer"], 'text/html');
              cartDrawer.innerHTML = html.querySelector('cart-drawer').innerHTML;
              cartDrawer.classList.add('animate', 'active');
          }
      } catch (error) {
          console.error("Error updating mini-cart:", error);
      }
  });
  
  